(function () {
    'use strict';

    angular
        .module('app.paymentTemplates')
        .controller('PaymentTemplateErrorController', PaymentTemplateErrorController);

    PaymentTemplateErrorController.$inject = ['$stateParams'];
    /* @ngInject */
    function PaymentTemplateErrorController($stateParams) {
        var vm = this;
        vm.title = 'Payment Error';
        vm.isLicenseValid = true;
        vm.errorMessage = "There was an unexpected error during processing.  Please try again later.";
        activate();

        function activate() {
            var val = $stateParams.errorCode;
            if (val) {
                vm.errorMessage = "Authorization Failed. Double check the information you entered for your payment.  If the problem persists contact your card-issuer.";
            }
        }


    }
})();
